module.exports = __webpack_public_path__ + "assets/img/2_751.967f8064.jpg";